import { render, staticRenderFns } from "./TreatmentMatrixPivot.vue?vue&type=template&id=aa073882"
import script from "./TreatmentMatrixPivot.vue?vue&type=script&lang=js"
export * from "./TreatmentMatrixPivot.vue?vue&type=script&lang=js"
import style0 from "./TreatmentMatrixPivot.vue?vue&type=style&index=0&id=aa073882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports